export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const RETRIEVE_MESSAGE = "RETRIEVE_MESSAGE";
export const RETRIEVESINGLE_MESSAGE = "RETRIEVESINGLE_MESSAGE";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";


